import { LinkExternal01Icon } from '@langchain/untitled-ui-icons';

import { InformationalBanner } from '@/components/InformationalBanner';
import { Button } from '@/design-system';

import { STARTUP_FORM_URL } from '../utils/constants';

export function StartupApplyNowButton() {
  return (
    <a href={STARTUP_FORM_URL} target="_blank" className="flex flex-row gap-1">
      <Button
        size="md"
        variant="outlined"
        color="secondary"
        rightDecorator={LinkExternal01Icon}
      >
        Apply Now
      </Button>
    </a>
  );
}

export function StartupPlanPendingInfoBox() {
  return (
    <div className="flex h-fit w-full rounded-xl bg-purple p-5">
      <div className="flex flex-col space-y-3">
        <span className="font-bold">
          Your application to our Startup Plan is in review
        </span>
        <span>
          You'll be notified via e-mail with the results of your application
        </span>
      </div>
    </div>
  );
}

function StartupPlanInfoBox() {
  return (
    <InformationalBanner noIcon={true} className={'bg-secondary'}>
      <div className="flex h-fit max-w-[560px] rounded-xl p-3">
        <div className="flex flex-col space-y-3">
          <span className="font-bold">
            Do you qualify for our LangSmith for Startups program?
          </span>
          <span>
            If you're an early stage startup, we want to work with you! Approved
            teams will get access to LangSmith with a generous starter plan.
          </span>
          <StartupApplyNowButton />
        </div>
      </div>
    </InformationalBanner>
  );
}

export default StartupPlanInfoBox;
